// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-626c0172]{display:none}.sf-circle-icon[data-v-626c0172]{--button-size:40px;--button-background:#ea580c;--button-box-shadow:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
